import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getRoomMasterdropdata } from '../Api/PropertyMst/Api';

export const fetchProperties = createAsyncThunk(
  'property/fetchProperties',
  async (_, { rejectWithValue }) => {
    try {
      const userId = sessionStorage.getItem('UserId');
      const response = await getRoomMasterdropdata({
        Flag: "",
        UserId: userId
      });
      if (response instanceof Error) throw response;
      return response.data.Data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const propertySlice = createSlice({
  name: 'property',
  initialState: {
    properties: [],
    globalProperty: null,
    localProperties: {},
    status: 'idle',
    error: null,
    isPropertyLocked: false,
    gatewayType: null  
  },
  reducers: {
    setGlobalProperty: (state, action) => {
      const selectedProperty = state.properties.find(p => p.Id === action.payload);
      state.globalProperty = action.payload;
         if (selectedProperty) {
        state.gatewayType = selectedProperty.GateWay_Type || null;
        sessionStorage.setItem('gatewayType', selectedProperty.GateWay_Type || '');
      }
      if (state.isPropertyLocked) {
        localStorage.setItem('selectedPropertyId', action.payload);
      }
    },
    setLocalProperty: (state, action) => {
      const { componentId, propertyId } = action.payload;
      state.localProperties[componentId] = propertyId;
    },
    setLockProperty: (state, action) => {
      state.isPropertyLocked = action.payload;
 
      if (action.payload) {
        localStorage.setItem('propertyLocked', 'true');
        if (state.globalProperty) {
          localStorage.setItem('selectedPropertyId', state.globalProperty);
        }
      } else {
        localStorage.removeItem('propertyLocked');
        localStorage.removeItem('selectedPropertyId');
      }
    },

    initializeFromStorage: (state) => {
      const savedLockState = localStorage.getItem('propertyLocked');
      const savedPropertyId = localStorage.getItem('selectedPropertyId');
      
      if (savedLockState === 'true') {
        state.isPropertyLocked = true;
      }
      
      if (savedPropertyId && state.isPropertyLocked) {
        state.globalProperty = savedPropertyId;
         const selectedProperty = state.properties.find(p => p.Id === parseInt(savedPropertyId));
        if (selectedProperty) {
          state.gatewayType = selectedProperty.GateWay_Type || null;
        }
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProperties.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProperties.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.properties = action.payload;

        const savedLockState = localStorage.getItem('propertyLocked');
        const savedPropertyId = localStorage.getItem('selectedPropertyId');
        
        if (savedLockState === 'true' && savedPropertyId) {
          state.isPropertyLocked = true;
          state.globalProperty = savedPropertyId;
           const selectedProperty = action.payload.find(p => p.Id === parseInt(savedPropertyId));
          if (selectedProperty) {
            state.gatewayType = selectedProperty.GateWay_Type || null;
          }
        } else if (action.payload.length > 0 && !state.globalProperty) {
          const firstProperty = action.payload[0];
          state.globalProperty = firstProperty.Id;
          state.gatewayType = firstProperty.GateWay_Type || null;
          sessionStorage.setItem('gatewayType', firstProperty.GateWay_Type || '');
        }
      })
      .addCase(fetchProperties.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  }
});

export const { 
  setGlobalProperty, 
  setLocalProperty, 
  setLockProperty,
  initializeFromStorage 
} = propertySlice.actions;

export const selectProperties = (state) => state.property.properties;
export const selectGlobalProperty = (state) => state.property.globalProperty;
export const selectLocalProperty = (state, componentId) =>
  state.property.localProperties[componentId];
export const selectPropertyStatus = (state) => state.property.status;
export const selectIsPropertyLocked = (state) => state.property.isPropertyLocked;
export const selectGatewayType = (state) => state.property.gatewayType;
export default propertySlice.reducer;